"use client";
import { useFormikContext } from "formik";
import { ReactElement } from "react";
import { useNavigate } from "react-router-dom";

import MDBox from "@/components/atoms/MDBox";
import { MDButton } from "@/components/atoms/MDButton";
import MDInput from "@/components/atoms/MDInput";
import { RecoverPasswordMessages } from "@/messages/recoverPassword/recover-password.messages";

import { loginName } from "../form-data";
import { RecoverPasswordFormData } from "../types";

type RecoverPasswordFormProps = {
  messages: RecoverPasswordMessages;
  isLoading: boolean;
  loadingIcon: ReactElement<unknown, string>;
};
export default function RecoverPasswordForm({
  messages,
  isLoading,
  loadingIcon,
}: RecoverPasswordFormProps) {
  const { values, errors, submitForm, handleChange } = useFormikContext<RecoverPasswordFormData>();
  const router = useNavigate();

  return (
    <>
      <MDBox mb={4}>
        <MDInput
          type="email"
          label={messages.emailLabel}
          variant="standard"
          fullWidth
          placeholder={messages.emailPlaceholder}
          name={loginName}
          onChange={handleChange}
          value={values?.login}
          error={!!errors?.login}
          helperText={errors?.login}
          InputLabelProps={{ shrink: true }}
        />
      </MDBox>
      <MDBox mt={6} mb={1} display="flex" alignItems="center" gap={2}>
        <MDButton
          variant="outlined"
          color="dark"
          fullWidth
          disabled={isLoading}
          onClick={() => router(-1)}
        >
          {messages.cancelAction}
        </MDButton>
        <MDButton
          variant="gradient"
          color="dark"
          fullWidth
          onClick={submitForm}
          disabled={isLoading}
        >
          {isLoading ? loadingIcon : messages.recoverAction}
        </MDButton>
      </MDBox>
    </>
  );
}
